import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KalProgressBarModule } from '@kalidea/kaligraphi';
import { ProgressOverlayComponent } from 'src/app/_shared/components/progress/components/progress-overlay/progress-overlay.component';
import { ProgressStepComponent } from 'src/app/_shared/components/progress/components/progress-step/progress-step.component';
import { ProgressOverlayDirective } from 'src/app/_shared/components/progress/directives/progress-overlay.directive';

@NgModule({
    imports: [
        CommonModule,
        KalProgressBarModule
    ],
    declarations: [
        ProgressOverlayComponent,
        ProgressStepComponent,
        ProgressOverlayDirective
    ],
    exports: [
        ProgressOverlayComponent,
        ProgressStepComponent,
        ProgressOverlayDirective
    ]
})
export class ProgressModule {}
